import ForEngineeringTeams from './for-engineering-teams.view';

export default ForEngineeringTeams;
